import { IOrderModel, IOrder } from 'models/Order';

export function ToOrderModel(order: IOrder): IOrderModel {
  return {
    ...order,
    digitalDelivery: order.digitalDelivery ? 'yes' : 'no',
    smsConsent: order.smsConsent,
    feedbackRecipient: order.feedbackRecipient
      ? { id: 'yes', name: 'orders.OPTION_DIGITAL_DELIVERY_YES' }
      : { id: 'no', name: 'orders.OPTION_DIGITAL_DELIVERY_NO' },
    attachments: [],
    additionalHealthCenters: order.additionalHealthCenters.map((u) => u.id),
    requestedDeliveryDateSpecification:
      order.requestedDate === null
        ? { name: 'orders.OPTION_REQUESTED_DELIVERYDATE_ASAP', id: 'asap' }
        : { name: 'orders.OPTION_REQUESTED_DELIVERYDATE_SPECIFIC_DATE', id: 'specificDate' },
    isBookedDateEmpty: false,
    customerUnitId: order.customerUnitId,
  } as IOrderModel;
}
